import { Platform } from 'react-native'

import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchBrandLeads } from '../functions/fetchBrandLeads'

function useBrandLeads(
  searchText?: string | undefined,
  customerId?: number | undefined
) {
  return useInfiniteQuery(
    ['brandLeads', { searchText }],
    ({ pageParam = 0 }) => {
      return fetchBrandLeads(pageParam || 0, searchText)
    },
    {
      getNextPageParam: (lastPage, pages) => {
        if (pages?.length * 10 <= lastPage?.count) {
          return lastPage?.nextOffset
        }
        return undefined
      },
      enabled: !!customerId && Platform.OS !== 'web',
    }
  )
}

export { useBrandLeads }
